module.exports = "/_next/static/images/calculator-duotone-a48fd6fcd2c18eee020491fef4d3c26a.svg";